module.exports = __webpack_public_path__ + "static/img/logo_05.73d5b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/logo_05.png
// module id = TBFR
// module chunks = 0